export interface BatchSchoolStatisticsAdvancementStudentSearchRequest {
  studentGrade: string
  studentClass: string
  fileName: string
}

export const defaultBatchSchoolStatisticsAdvancementStudentSearchRequest = (): BatchSchoolStatisticsAdvancementStudentSearchRequest => ({
  studentGrade: '',
  studentClass: '',
  fileName: ''
})

export function BatchSchoolStatisticsAdvancementStudentSearchRequestToJSON(
  value: BatchSchoolStatisticsAdvancementStudentSearchRequest
): any {
  return {
    student_grade: value.studentGrade !== '' ? value.studentGrade : undefined,
    student_class: value.studentClass !== '' ? value.studentClass : undefined,
    file_name: value.fileName !== '' ? value.fileName : undefined
  }
}
